import Box from '@mui/material/Box'
import Skeleton from '@mui/material/Skeleton'
import Stack from '@mui/material/Stack'

export type SkeletonSideNavProps = {
    items?: number
    width?: number
    showHeader?: boolean
}

export default function SkeletonSideNav(props: Readonly<SkeletonSideNavProps>) {
    const { items = 10, width = 230, showHeader = true } = props

    return (
        <Box
            sx={{
                width,
                flexShrink: 0,
                display: { xs: 'none', md: 'block' },
                borderRight: '1px solid',
                borderColor: 'divider',
            }}
        >
            {showHeader && (
                <Stack spacing={1} sx={{ bgcolor: 'common.black', px: 2, py: 1.5 }}>
                    <Skeleton variant="text" width="55%" sx={{ bgcolor: 'grey.800' }} />
                    <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
                        <Skeleton
                            variant="rounded"
                            width={16}
                            height={16}
                            sx={{ bgcolor: 'grey.800' }}
                        />
                        <Skeleton variant="text" width="70%" sx={{ bgcolor: 'grey.800' }} />
                    </Stack>
                    <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
                        <Skeleton
                            variant="circular"
                            width={16}
                            height={16}
                            sx={{ bgcolor: 'grey.800' }}
                        />
                        <Skeleton variant="text" width="55%" sx={{ bgcolor: 'grey.800' }} />
                    </Stack>
                </Stack>
            )}

            <Stack sx={{ py: 1 }}>
                {Array.from({ length: items }, (_, index) => (
                    <Box key={index} sx={{ px: 2, py: 1.25 }}>
                        <Skeleton variant="text" width={`${45 + ((index * 13) % 40)}%`} />
                    </Box>
                ))}
            </Stack>
        </Box>
    )
}
